import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 推荐直播
export const recommendLiveList = (): any => http.httpGet({
    url: httpApi.liveBroadRoom.recommendLiveList,
})

// 获取拉流地址
interface GetPullUrlJson {
    live_no: string,
    clarity: string,
}
export const getPullUrl = (json: GetPullUrlJson): any => http.httpPost({
    url: httpApi.liveBroadRoom.getPullUrl,
    json
})

// 直播列表
interface LiveListJson {
    game_id: string,
    game_server: string,
    tag: string,
    version_id: string,
    page: number,
    limit: number,
}
export const liveList = (json: LiveListJson): any => http.httpGet({
    url: httpApi.liveBroadRoom.liveList,
    json
})

// 礼物列表
interface GiftListJson {
    page: number,
    limit: number,
    type: number,
}
export const giftList = (json: GiftListJson): any => http.httpGet({
    url: httpApi.liveBroadRoom.giftList,
    json
})

// 主播中心设置
interface AnchorCenterJson {
    token: string,
}

export const anchorCenter = (json: AnchorCenterJson) => http.httpPost({
    url: httpApi.liveBroadRoom.anchorCenter,
    json
})

// 主播中心设置保存
interface AnchorCenterSaveJson {
    token: string,
    live_title: string,
    tag: string,
    tag_name: string,
    version_name: string,
    version_id: string,
    game_id: number,
    game_server: number,
    game_name: string,
    server_name: string,
}

export const anchorCenterSave = (json: AnchorCenterSaveJson) => http.httpPost({
    url: httpApi.liveBroadRoom.anchorCenterSave,
    json
})

// 开始直播
interface BeginLiveJson {
    token: string,
    roomName: string,
    description: string,
    cover: string,
    tag: string,
    version_id: string,
}

export const beginLive = (json: BeginLiveJson) => http.httpGet({
    url: httpApi.liveBroadRoom.beginLive,
    json
})

// 结束直播
interface EndLiveJson {
    token: string,
    live_id: number,
}

export const endLive = (json: EndLiveJson) => http.httpGet({
    url: httpApi.liveBroadRoom.endLive,
    json
})

// 直播记录
interface LiveRecordJson {
    token: string,
    begin_time: string,
    end_time: string,
    page: number,
    limit: number,
}

export const liveRecord = (json: LiveRecordJson) => http.httpGet({
    url: httpApi.liveBroadRoom.liveRecord,
    json
})

// 获取推流地址（CDN推拉流）
interface GetPushKeyJson {
    token: string,
}

export const getPushKey = (json: GetPushKeyJson) => http.httpGet({
    url: httpApi.liveBroadRoom.getPushKey,
    json
})

// 获取推流地址（CDN推拉流）
interface ClosePushUrlJson {
    token: string,
}

export const closePushUrl = (json: ClosePushUrlJson) => http.httpGet({
    url: httpApi.liveBroadRoom.closePushUrl,
    json
})

// 礼物列表
interface FollowListJson {
    token: string,
    page: number,
    limit: number,
}
export const followList = (json: FollowListJson): any => http.httpGet({
    url: httpApi.liveBroadRoom.followList,
    json
})

// 主播中心标题保存
interface AnchorCenterSaveTitleJson {
    token: string,
    live_title: string,
}
export const anchorCenterSaveTitle = (json: AnchorCenterSaveTitleJson): any => http.httpPost({
    url: httpApi.liveBroadRoom.anchorCenterSaveTitle,
    json
})
